export const CREATE_SHOP_ACTION = '[Shop Action] Create Shop';
export const CONFIRMED_CREATE_SHOP_ACTION = '[Shop Action] Confirmed Create Shop';
export const GET_SHOPS = '[Shop Action] Get Shops';
export const CONFIRMED_GET_SHOPS = '[Shop Action] Confirmed Get Shops';
export const EDIT_SHOP_ACTION = '[Shop Action] Edit Shop';
export const CONFIRMED_EDIT_SHOP_ACTION = '[Shop Action] Confirmed Edit Shop';
export const CONFIRMED_DELETE_SHOP_ACTION = '[Shop Action] Confirmed Delete Shop';
export const CREATE_SHOP_ERROR_ACTION = '[Shop Action] Error';
export const CLEAR_SHOP_ERROR = '[Shop Action] Clear Error';


